import React from "react";

interface AcsIframeProps {
  url: string;
  isActive: boolean;
}

export default function AcsIframe({ url, isActive }: AcsIframeProps) {
  return (
    <div
      className={`acs-iframe-container ${
        isActive ? "acs-iframe-container--active" : ""
      }`}
    >
      <iframe
        src={url}
        title="ACS Call Session"
        className="acs-iframe"
        allow="camera; microphone; display-capture; fullscreen; autoplay; screen-wake-lock"
        frameBorder="0"
        scrolling="no"
      />
    </div>
  );
}
